import { ProductionPage } from "./ProductionPage"

export function ProductionBomPage() {
  return <ProductionPage mode="bom" />
}
